import { GRID_COLUMNS, type CharacterGridSpec } from "@/character/grid";

export const SKILL_FRAME_COUNT = GRID_COLUMNS;

export type SkillFrameRect = {
  x: number;
  y: number;
  w: number;
  h: number;
};

export type SkillFrameLayout = {
  frames: SkillFrameRect[];
};

export function defaultSkillFrameLayout(width: number, height: number): SkillFrameLayout {
  const fw = width / SKILL_FRAME_COUNT;
  const frames: SkillFrameRect[] = [];
  for (let i = 0; i < SKILL_FRAME_COUNT; i += 1) {
    frames.push({
      x: i * fw,
      y: 0,
      w: fw,
      h: height,
    });
  }
  return { frames };
}

function clampRect(rect: SkillFrameRect, maxW: number, maxH: number): SkillFrameRect {
  const w = Math.max(8, Math.min(rect.w, maxW));
  const h = Math.max(8, Math.min(rect.h, maxH));
  const x = Math.max(0, Math.min(rect.x, maxW - w));
  const y = Math.max(0, Math.min(rect.y, maxH - h));
  return { x, y, w, h };
}

export function normalizeSkillFrameLayout(
  raw: SkillFrameLayout | undefined,
  imageWidth: number,
  imageHeight: number,
): SkillFrameLayout {
  if (!raw?.frames || raw.frames.length !== SKILL_FRAME_COUNT) {
    return defaultSkillFrameLayout(imageWidth, imageHeight);
  }
  return {
    frames: raw.frames.map((f) => clampRect(f, imageWidth, imageHeight)),
  };
}

/** @deprecated use SkillFrameLayout */
export type SkillGridTuning = SkillFrameLayout;

export function defaultSkillGridTuning(): SkillFrameLayout {
  return { frames: [] };
}

export function skillGridTuningForImage(width: number, height: number): SkillFrameLayout {
  return defaultSkillFrameLayout(width, height);
}

/** Frame rects on an already-exported 6-column skill spritesheet. */
export function frameLayoutFromOutputSheet(grid: CharacterGridSpec): SkillFrameLayout {
  const frames: SkillFrameRect[] = [];
  for (let i = 0; i < SKILL_FRAME_COUNT; i += 1) {
    frames.push({
      x: i * grid.frameWidth,
      y: 0,
      w: grid.frameWidth,
      h: grid.frameHeight,
    });
  }
  return { frames };
}
